export const eur = (cents) => {
  const v = (cents || 0) / 100;
  return v.toLocaleString("es-ES", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " €";
};

export const eurPerSecond = (cents) => {
  const v = (cents || 0) / 100;
  return v.toLocaleString("es-ES", { minimumFractionDigits: 3, maximumFractionDigits: 3 }) + " €/seg";
};

export const eurPerMin = (perSecondCents) => {
  const v = ((perSecondCents || 0) * 60) / 100;
  return v.toLocaleString("es-ES", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " €/min";
};

export const fmtDuration = (totalSeconds) => {
  const s = Math.max(0, Math.floor(totalSeconds || 0));
  const m = Math.floor(s / 60);
  const sec = s % 60;
  const h = Math.floor(m / 60);
  const min = m % 60;
  if (h > 0) return `${String(h).padStart(2, "0")}:${String(min).padStart(2, "0")}:${String(sec).padStart(2, "0")}`;
  return `${String(min).padStart(2, "0")}:${String(sec).padStart(2, "0")}`;
};

export const relTime = (iso) => {
  const d = new Date(iso);
  const diffMs = Date.now() - d.getTime();
  const s = Math.round(diffMs / 1000);
  if (s < 60) return "hace un momento";
  const m = Math.round(s / 60);
  if (m < 60) return `hace ${m} min`;
  const h = Math.round(m / 60);
  if (h < 24) return `hace ${h} h`;
  const days = Math.round(h / 24);
  if (days < 7) return `hace ${days} d`;
  const w = Math.round(days / 7);
  if (w < 5) return `hace ${w} sem`;
  return d.toLocaleDateString("es-ES", { day: "2-digit", month: "short" });
};

export const formatBookingDateEs = (dateString) => {
  const [year, month, day] = dateString.split("-").map(Number);
  const date = new Date(year, month - 1, day);
  return new Intl.DateTimeFormat("es-ES", {
    day: "numeric",
    month: "short",
    year: "numeric",
  }).format(date).replace(".", "");
};

export const initialsOf = (name) => {
  if (!name) return "?";
  const parts = name.trim().split(/\s+/);
  return (parts[0][0] + (parts[1]?.[0] || "")).toUpperCase();
};
